<template lang="pug">
AppPopover(
  ref="AppPopover"
  placement="top"
  hide-close
)
  span(slot="body")
    slot(name="body")
  span(slot="trigger")
    slot(name="trigger")
</template>

<script>
export default {
  name: 'AppHintPopover',
  mounted() {
    this.$refs.AppPopover.open();
  },
};
</script>
